import { ValidationObserver } from "vee-validate/dist/vee-validate.full";
import BForm from "@/components/singles/BForm/component.vue";
import EditableText from "@/components/singles/EditableText/component.vue";
import BModal from "@/components/singles/BModal/component.vue";

export default {
  name: "role-management",
  components: {
    ValidationObserver,
    BForm,
    EditableText,
    BModal
  },
  props: [],
  data() {
    return {
      showModal: false,
      items: [],

      form: {
        valid: false,
        inputs: [
          {
            name: "role",
            placeholder: "Role name",
            type: "text",
            validation: "required|min:3",
            value: "",
            focus: true
          },
          {
            name: "level",
            placeholder: "Level",
            type: "number",
            validation: "required|digits:1",
            value: ""
          }
        ]
      }
    };
  },
  computed: {
    orderedItems: function() {
      return _.orderBy(this.items, "level");
    }
  },
  created() {
    this.GetItems();
  },
  mounted() {},
  methods: {
    async Save() {
      this.SaveBefore();

      if (!this.items.find(x => x.level == this.form.inputs[1].value)) {
        this.$helpers
          .PostApi("create/role", {
            name: this.form.inputs[0].value,
            level: parseInt(this.form.inputs[1].value)
          })
          .then(res => {
            this.SaveSuccessful(res);
          })
          .catch(err => {
            this.SaveError(err);
          });
      } else {
        this.$helpers.ShowStatus(
          "A role with this level already exists",
          5000,
          "warning"
        );

        this.form.valid = false;
        this.form.inputs[1].value = null;
        this.$store.state.loading = false;
      }
    },

    SaveBefore() {
      this.$store.state.loading = true;
    },
    SaveSuccessful(res) {
      this.showModal = false;
      var newItem = res[0];
      this.$helpers.ShowNotification("Saved", "success", 3000);
      this.items.push(newItem);
      this.$store.state.loading = false;
      this.$helpers.ClearForm(this.form);
    },
    SaveError(err) {
      this.$store.state.loading = false;
      this.$helpers.ShowNotification(err.statusText, "danger");
      console.log(err);
    },

    Delete(item) {
      this.$helpers
        .PostApi("delete/role", {})
        .then(res => {
          this.items = res[0];
        })
        .catch(err => {
          console.log(err);
        });
    },

    async GetItems() {
      this.$helpers
        .PostApi("get/roles", {})
        .then(res => {
          this.items = res[0];
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
